export default __webpack_public_path__ + "static/media/Cluedo-Nudges-Teachers-Magnify.62cc9d4c.svg";